angular.module('offlineChecker')
  .factory('encryptionFactory', encryptionFactory);

function encryptionFactory(){
  var cryptor = {
    encrypt: encrypt,
    decrypt: decrypt
  };
  return cryptor;

  function decrypt(value, password){
    var params = {}, rp = {};
    var decryptedVal = sjcl.decrypt(password, value, params, rp);
    return JSON.parse(decryptedVal);
  }

  function encrypt(value, password){
    var params = {}, rp = {};
    value = JSON.stringify(value);
    var encryptedVal = sjcl.encrypt(password, value, params, rp);
    return encryptedVal;
  }
}
